import React, { ReactNode } from 'react';
import { styles } from './MultiColumnEntry.css';
import { classNames } from '@jbhi-fi/lanyard-ui/global/utils';
import { useResponsiveValue } from '../hooks/useResponsiveValue';
import { ContentThemePalette } from '../Contentful/transformers/ThemeTransformer';

export interface MultiColumnEntryProps {
  alignment: 'Left' | 'Centred';
  heading: string;
  headingSize: 'Small' | 'Medium' | 'Large';
  subText: ReactNode;
  image: ReactNode;
  imageSize: 'Third' | 'Half' | 'Full' | 'Thumbnail';
  button?: ReactNode;
  theme?: ContentThemePalette;
}

export const MultiColumnEntry = ({
  alignment,
  heading,
  headingSize = 'Medium',
  subText,
  image,
  imageSize,
  button,
  theme,
}: MultiColumnEntryProps) => {
  const imageSizeClass = {
    Third: styles.imageContainerSmall,
    Half: styles.imageContainerMedium,
    Full: styles.imageContainerLarge,
    Thumbnail: styles.imageContainerThumbnail,
  }[imageSize];

  const headingSizeElementMap = {
    Small: { xs: 'h5', md: 'h4' } as const,
    Medium: { xs: 'h4', md: 'h3' } as const,
    Large: { xs: 'h3', md: 'h2' } as const,
  }[headingSize];

  const headingSizeElement = useResponsiveValue<'h2' | 'h3' | 'h4' | 'h5'>(headingSizeElementMap);

  return (
    <div className={styles.container({ alignment })} style={{ backgroundColor: theme?.background }}>
      <div className={classNames([styles.imageContainerBase, imageSizeClass])}>{image}</div>
      {React.createElement(
        headingSizeElement,
        { className: styles.heading({ headingSizeElement: headingSizeElement as 'h2' | 'h3' | 'h4' | 'h5' }) },
        heading
      )}
      <div className={styles.subtext}>{subText}</div>
      <div className={styles.buttonContainer}>{button}</div>
    </div>
  );
};
